import { createContext } from "react";
import {
  InterfaceConfiguration,
  InterfaceConfigurationParameters,
} from "../../interfaces";

export interface ContextProps {
  interfaceInternalConfiguration: {} | null;
  locatorConfigurationIsLoading: boolean;
  interfaceConfiguration: InterfaceConfiguration | null;
  interfaceNotFound: boolean;

  setLocatorConfiguration: (
    paremeters: InterfaceConfigurationParameters
  ) => void;
}
export const LocatorConfigurationContext = createContext({} as ContextProps);
